import { createContext, useContext } from 'react';

export const StationSlugContext = createContext<string | null>(null);

export function useStationSlug(): string | null {
  return useContext(StationSlugContext);
}
